define(['jquery', 'core/ajax', 'core/notification', 'core/url', 'core/modal_factory', 'core/modal_events', 'core/templates', 'core/str',
'datatables.net',
'datatables.net-bs4',
'datatables.net-buttons',
'datatables.net-buttons-bs4',
'datatables.net-buttons-html',
'datatables.net-buttons-flash',
'datatables.net-responsive',
'datatables.net-responsive-bs4'],
    function($, ajax, notification, moodleurl, modalFactory, modalEvents, templates, str){
        'use strict';
        var index = {
            dom: {
                main: null,
                table: null,
                startDate: null,
                endDate: null
            },
            variable: {
                dataTableReference: null
            },
            url: {
                downloadExcel: function() {
                    return moodleurl.relativeUrl('/local/custom_auth/trainer_application_download.php', {startdate: index.dom.startDate.val(), enddate: index.dom.endDate.val()});
                },
                downloadAllDoc: function(userId) {
                    return moodleurl.relativeUrl('/local/custom_auth/trainersdocszip.php', {id: userId});
                }
            },
            langs: {
                success: null,
                successMessage: null,
                error: null,
                failedMessages: null,
                accept: null,
                reject: null,
                applicationApprove: null,
                wantToAccept: null,
                provideComment: null,
                wantToReject: null,
                appReject: null,
                downloadAll: null,
                na: null,
            },
            action: {
                getString: function() {
                    str.get_strings([
                        {key: 'success', component: 'local_custom_auth'},
                        {key: 'successmessage', component: 'local_custom_auth'},
                        {key: 'error', component: 'local_custom_auth'},
                        {key: 'failedmessages', component: 'local_custom_auth'},
                        {key: 'accept', component: 'local_custom_auth'},
                        {key: 'reject', component: 'local_custom_auth'},
                        {key: 'applicationapprove', component: 'local_custom_auth'},
                        {key: 'wanttoaccept', component: 'local_custom_auth'},
                        {key: 'providecomment', component: 'local_custom_auth'},
                        {key: 'wanttoreject', component: 'local_custom_auth'},
                        {key: 'appreject', component: 'local_custom_auth'},
                        {key: 'downloadall', component: 'local_custom_auth'},
                        {key: 'na', component: 'local_custom_auth'},
                    ]).then(function(s){
                        index.langs.success = s[0];
                        index.langs.successMessage = s[1];
                        index.langs.error = s[2];
                        index.langs.failedMessages = s[3];
                        index.langs.accept = s[4];
                        index.langs.reject = s[5];
                        index.langs.applicationApprove = s[6];
                        index.langs.wantToAccept = s[7];
                        index.langs.provideComment = s[8];
                        index.langs.wantToReject = s[9];
                        index.langs.appReject = s[10];
                        index.langs.downloadAll = s[11];
                        index.langs.na = s[12];
                        index.init();
                    }).fail(function(e){

                    });
                }
            },
            updateApplication: function(e, status, comment, userId, row) {
                var promises = ajax.call([{
                    args: {
                        status: status,
                        comment: comment,
                        userid: userId,
                        type: 'profile'
                    },
                    methodname: 'local_custom_auth_update_user_approval'
                }]);
                promises[0].done(function(data) {
                    if (data == true) {
                        notification.addNotification({
                            type: 'success',
                            message: index.langs.successMessage
                        });
                        setTimeout(function() {
                            $('.alert-success').hide();
                        }, 4000);
                    } else {
                        notification.addNotification({
                            type: 'error',
                            message: index.langs.failedMessages
                        });
                    }
                    e.hide();
                        index.variable.dataTableReference.ajax.reload();
                }).fail(function() {
                     notification.addNotification({
                        type: 'error',
                        message: index.langs.failedMessages
                    });
                });
            },
            init: function() {
                index.dom.main = $(document).find('.main');
                index.dom.table = index.dom.main.find('.trainer-application-table');

                index.dom.startDate = index.dom.main.find('.start-date');
                //alert(index.dom.startDate);
                index.dom.endDate = index.dom.main.find('.end-date');

                index.dom.main.on('click', '.buttons-html6', function(e) {
                    window.location.href = index.url.downloadExcel();
                });
                index.variable.dataTableReference = index.dom.table.DataTable({
                    pagingType: "simple_numbers",
                    processing: true,
                    serverSide: true,
                    order: [],
                    aoColumnDefs: [
                        { "bSortable": false, "aTargets": [7]},
                        { "bSortable": false, "aTargets": [6]},
                        { "bSortable": false, "aTargets": [9]},
                        { "bSortable": false, "aTargets": [4]}
                    ],
                    searching: true,
                    ajax: function(data, callBack) {
                        var d;
                        if (index.dom.startDate.val()) {
                            d = new Date(index.dom.startDate.val());
                            data.startdate = d.getTime() / 1000;
                        }
                        if (index.dom.endDate.val()) {
                            d = new Date(index.dom.endDate.val());
                            data.enddate = d.getTime() / 1000;
                        }
                        var promises = ajax.call([{
                            methodname: 'local_custom_auth_get_trainer_applications',
                            args: data
                        }]);
                        promises[0].done(callBack).fail(function(){
                        });
                    },
                    columns: [{
                        data: 'fullname',
                    },{
                        data: 'email',

                    },{
                        data: 'phone',

                    },{
                        data: 'timecreated',

                    },{
                        data: 'files',
                        render: function(data) {
                            var docs = '';
                            for (var i = 0; i < data.length; i++) {
                                docs += '<b>' + data[i].type + '</b>: <a href="' + data[i].url + '" target="__blank">'+ data[i].type + '</a><br/>';
                            }
                            if (docs == '') {
                                docs += index.langs.na;
                            } else {
                                docs += '<a href="" class="downloadalldoc" data-id="' + arguments[2].userid + '">' + index.langs.downloadAll + '</a>';
                            }
                            return docs;
                        }
                    },{
                        data: 'status',
                    },{
                        data: 'approvedby',
                    },{
                       data: 'comment',
                       render: function(data) {
                            if (data === null) {
                                return index.langs.na;
                            } else {
                                return data;
                            }
                       }
                    },{
                        data: 'timemodified',
                        render: function(data) {
                            if (data === null) {
                                return index.langs.na;
                            } else {
                                return data;
                            }
                        }
                    },{
                        data: 'userid',
                        render: function(data) {
                            return '<button class="btn btn-success accept-application" data-id="' + data + '">' + index.langs.accept + '</button>' +
                                    '<button class="btn btn-danger reject-application" data-id="' + data + '">' + index.langs.reject + '</button>';
                        }
                    }],
                    createdRow: function (row, data, index ) {
                        if (data.numericstatus == "1") {
                            $('td', row).eq(9).find('.accept-application').hide();
                        } else if (data.numericstatus == "2" && data.comment !== null){
                            $('td', row).eq(9).find('.reject-application').hide();
                        } else {
                            $('td', row).eq(9).find('.accept-application').show();
                            $('td', row).eq(9).find('.reject-application').show();
                        }
                    }
                });
                // Download all click
                index.dom.table.on('click', '.downloadalldoc', function(e){
                    e.preventDefault();
                    var userId = $(e.currentTarget).data('id');
                    window.location.href = index.url.downloadAllDoc(userId);

                });
                index.dom.main.on('change', '.trainer_report_filter input, .trainer_report_filter select',
                function(e) {
                    if ($(e.currentTarget).attr('class') === index.dom.startDate.attr('class')) {
                        var date = new Date(index.dom.startDate.val())
                        date.setDate(date.getDate() + 1);
                        index.dom.endDate.attr('min', date.getFullYear() + '-' + (date.getMonth() + 1 ) + '-' + date.getDate());
                    }
                    index.variable.dataTableReference.ajax.reload();
                });

                index.dom.table.on('click', 'tr .accept-application', function(row) {
                    var userId = $(row.currentTarget).data('id');
                    modalFactory.create({
                        type: modalFactory.types.SAVE_CANCEL,
                        title: index.langs.applicationApprove,
                        body: templates.render('local_custom_auth/applicationapprovalmodal', {
                            description: index.langs.wantToAccept
                        })
                    }).then(function (modal) {
                        var root = modal.getRoot();
                        root.on(modalEvents.save, function (e) {
                            e.preventDefault();
                            root.find('.user-notifications').removeClass('alert alert-danger').html('');
                            if (root.find('.update-application-comment').val().trim() == '') {
                                root.find('.user-notifications').addClass('alert alert-danger').html(index.langs.provideComment);
                                return false;
                            } else {
                                var status = 1; // Approved.
                                index.updateApplication(modal, status, root.find('.update-application-comment').val().trim(), userId, row);
                                root.find('button').attr('disabled', true);
                            }
                        });
                        modal.show();
                    });
                });

                index.dom.table.on('click', 'tr .reject-application', function (row) {
                    var userId = $(row.currentTarget).data('id');
                    modalFactory.create({
                        type: modalFactory.types.SAVE_CANCEL,
                        title: index.langs.appReject,
                        body: templates.render('local_custom_auth/applicationapprovalmodal', {
                            description: index.langs.wantToReject
                        })
                    }).then(function (modal) {
                        var root = modal.getRoot();
                        root.on(modalEvents.save, function (e) {
                            e.preventDefault();
                            root.find('.user-notifications').removeClass('alert alert-danger').html('');
                            if (root.find('.update-application-comment').val().trim() == '') {
                                root.find('.user-notifications').addClass('alert alert-danger').html(index.langs.provideComment);
                                return false;
                            } else {
                                var status = 2; // Rejected.
                                index.updateApplication(modal, status, root.find('.update-application-comment').val().trim(), userId, row);
                                root.find('button').attr('disabled', true);
                            }
                        });
                        modal.show();
                    });
                });

            }
        };
        return {
            init: index.action.getString
        };
});